var _rect, _rect2, _circle, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgExchange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 94,
    viewBox: "0 0 28 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 13.1592,
    y: 62.5664,
    width: 0.867834,
    height: 31.242,
    fill: "#000A62"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 13.1592,
    y: 0.0820312,
    width: 0.867834,
    height: 31.242,
    fill: "#000A62"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13.593,
    cy: 47.3792,
    r: 13.4514,
    fill: "#1A2CCE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8726 44.3788C12.9219 44.479 12.9993 44.5637 13.0961 44.6231C13.1928 44.6824 13.3049 44.7141 13.4194 44.7144L15.2421 44.7144L15.2421 49.4255C15.2421 49.5817 15.3061 49.7315 15.4201 49.8419C15.534 49.9524 15.6885 50.0144 15.8497 50.0144L17.0648 50.0144C17.2259 50.0144 17.3805 49.9524 17.4944 49.8419C17.6083 49.7315 17.6724 49.5817 17.6724 49.4255L17.6724 44.7144L19.495 44.7144C19.6118 44.7143 19.726 44.6815 19.8241 44.6201C19.9222 44.5587 19.9999 44.4711 20.0479 44.368C20.096 44.2649 20.1124 44.1505 20.0952 44.0386C20.0779 43.9266 20.0278 43.8219 19.9507 43.7369L16.7732 40.2036C16.7162 40.1407 16.6461 40.0904 16.5676 40.0559C16.489 40.0214 16.4038 40.0034 16.3175 40.0033C16.2283 40.0055 16.1407 40.0266 16.0609 40.0653C15.9811 40.104 15.911 40.1592 15.8557 40.2271L12.9577 43.7604C12.8852 43.8454 12.8388 43.9485 12.8237 44.0578C12.8087 44.1671 12.8256 44.2783 12.8726 44.3788ZM15.1814 52.1168C15.1321 52.0165 15.0547 51.9319 14.9579 51.8725C14.8612 51.8131 14.7491 51.7814 14.6346 51.7811L12.8119 51.7811L12.8119 47.07C12.8119 46.9138 12.7479 46.764 12.6339 46.6536C12.52 46.5431 12.3654 46.4811 12.2043 46.4811L10.9892 46.4811C10.828 46.4811 10.6735 46.5431 10.5596 46.6536C10.4456 46.764 10.3816 46.9138 10.3816 47.07L10.3816 51.7811L8.55894 51.7811C8.44218 51.7812 8.32794 51.814 8.22988 51.8754C8.13183 51.9369 8.05411 52.0244 8.00604 52.1275C7.95796 52.2306 7.94157 52.345 7.95881 52.4569C7.97606 52.5689 8.02621 52.6736 8.10327 52.7586L11.2808 56.292C11.3377 56.3548 11.4078 56.4051 11.4864 56.4396C11.565 56.4742 11.6502 56.4921 11.7365 56.4922C11.8257 56.49 11.9133 56.4689 11.9931 56.4302C12.0729 56.3915 12.1429 56.3363 12.1982 56.2684L15.0963 52.7351C15.1688 52.6501 15.2152 52.547 15.2302 52.4377C15.2453 52.3284 15.2283 52.2172 15.1814 52.1168Z",
    fill: "#FBFBFB"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExchange);
export default __webpack_public_path__ + "static/media/exchange.958401722308e4f23d002f26bbc4e047.svg";
export { ForwardRef as ReactComponent };